import type { ReactElement } from 'react'

import { getPaymentMethodDisplayText } from '@b-stock/fe-core/bstock-next/components'
import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import type { PayMethod } from '@b-stock/payments-methods-api-client'
import { PayMethodTypeEnum } from '@b-stock/payments-methods-api-client'

const ns = 'BidConfirmationModal.autoPay.modal.paymentMethods'

/**
 * Filters payment methods to exclude unsupported types for auto-pay
 * (excludes wire transfer and other unsupported methods)
 */
export const filterAutoPaySupportedMethods = (
  methods: PayMethod[]
): PayMethod[] => {
  const supportedTypes: PayMethodTypeEnum[] = [
    PayMethodTypeEnum.Getbalance,
    PayMethodTypeEnum.Card,
    PayMethodTypeEnum.Bank,
    PayMethodTypeEnum.StripeFinConn,
    PayMethodTypeEnum.GetbalanceCc,
  ]

  return methods.filter((method) => supportedTypes.includes(method.type))
}

export const getPaymentMethodLabel = (
  paymentMethods: PayMethod[],
  paymentMethodId: string | null | undefined
): ReactElement => {
  if (paymentMethods.length === 0) {
    return <FormattedMessage id={`${ns}.addToContinue`} />
  }

  if (!paymentMethodId) {
    return <FormattedMessage id={`${ns}.selectToContinue`} />
  }

  const method = paymentMethods.find((pm) => pm.id === paymentMethodId)
  if (!method) {
    return <FormattedMessage id={`${ns}.methodUnavailable`} />
  }

  return getPaymentMethodDisplayText(method)
}
